
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { TrendingUp, TrendingDown } from "lucide-react";

interface SummaryCardsProps {
  analytics: {
    totalRevenue: number;
    totalExpenses: number;
    netProfit: number;
    profitMargin: number;
    averageOrderValue: number;
    totalOrders: number;
    primaryCurrency: string;
  };
  formatPrice: (amount: number, currency?: string) => string;
}

const ReportsSummaryCards = ({ analytics, formatPrice }: SummaryCardsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Total Revenue</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold text-green-600">
            {formatPrice(analytics.totalRevenue, analytics.primaryCurrency)}
          </div>
          <div className="flex items-center mt-2">
            <Badge variant="outline" className="bg-green-50 text-green-700">
              {analytics.totalOrders} orders
            </Badge>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Total Expenses</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold text-red-600">
            {formatPrice(analytics.totalExpenses, analytics.primaryCurrency)}
          </div>
          <div className="flex items-center mt-2">
            <Badge variant="outline" className="bg-red-50 text-red-700">
              Business costs
            </Badge>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Net Profit</CardTitle>
        </CardHeader>
        <CardContent>
          <div className={`text-3xl font-bold ${analytics.netProfit >= 0 ? 'text-green-600' : 'text-red-600'}`}>
            {formatPrice(analytics.netProfit, analytics.primaryCurrency)}
          </div>
          <div className="flex items-center mt-2">
            {analytics.netProfit >= 0 ? (
              <TrendingUp className="h-4 w-4 text-green-600 mr-1" />
            ) : (
              <TrendingDown className="h-4 w-4 text-red-600 mr-1" />
            )}
            <Badge variant="outline" className={analytics.netProfit >= 0 ? "bg-green-50 text-green-700" : "bg-red-50 text-red-700"}>
              {analytics.profitMargin.toFixed(1)}% margin
            </Badge>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Avg Order Value</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold text-blue-600">
            {formatPrice(analytics.averageOrderValue, analytics.primaryCurrency)}
          </div>
          <div className="flex items-center mt-2">
            <Badge variant="outline" className="bg-blue-50 text-blue-700">
              Per order
            </Badge>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ReportsSummaryCards;
